import React, { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import Modal from 'react-modal';
import HashLoader from "react-spinners/HashLoader";


const styleTitle = {
  fontSize: 22,
  color: "#4a54f1",
  textAlign: "center",
  paddingTop: "30px",
  paddingBottom: "30px",
  textShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)", // Menambahkan efek bayangan pada teks
  fontWeight: "bold", // Membuat teks menjadi tebal
  fontFamily: "Arial, sans-serif", // Mengubah jenis font menjadi Arial atau font lainnya
};

function Dukcapil() {
  const [src, setSrc] = useState(null);
  const [detectedText, setDetectedText] = useState(null);
  const [nama, setNama] = useState(null);
  const [tanggalLahir, setTanggalLahir] = useState(null);
  const [tempatLahir, setTempatLahir] = useState(null);
  const [jenisKelamin, setJenisKelamin] = useState(null);
  const [alamat, setAlamat] = useState(null);
  const [statusPerkawinan, setStatusPerkawinan] = useState(null);
  const [jenisPekerjaan, setJenisPekerjaan] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onPaste = (event) => {
      if (!isModalOpen) return;
  
      const items = event.clipboardData.items;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile();
          onSelectFile(file);
          break;
        }
      }
    };
    document.addEventListener('paste', onPaste);
  return () => {
    document.removeEventListener('paste', onPaste);
  };
}, [isModalOpen]);

  const onSelectFile = (file) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      setSrc(reader.result);
      uploadAndDetectText(file);
      setIsModalOpen(false);
    });
    reader.readAsDataURL(file);
  };

  const extractText = (text, startIndex) => {
    const normalizedText = text.replace(/\s/g, ' ');
    const remainingText = normalizedText.substring(startIndex);
    const firstDigitIndex = remainingText.search(/\d/);
    let processedText = firstDigitIndex !== -1 
      ? remainingText.substring(0, firstDigitIndex + 1) 
      : remainingText;
    return processedText.slice(0, -2);
  };

  const extractUntilCstm = (text, startIndex, delimiter) => {
    const normalizedText = text.replace(/\s/g, ' ');
    const remainingText = normalizedText.substring(startIndex);
    const delimiterIndex = remainingText.indexOf(delimiter);
    const result = delimiterIndex !== -1 
      ? remainingText.substring(0, delimiterIndex) 
      : remainingText;
    return result.trim();
  };
  
  const extractStatusPerkawinan = (text, startIndex) => {
    const normalizedText = text.replace(/\s/g, ' ');
    const remainingText = normalizedText.substring(startIndex);
    const keywords = ['KAWIN', 'BELUM KAWIN', 'CERAI HIDUP', 'CERAI MATI'];
    let delimiterIndex = -1;

    for (const keyword of keywords) {
      const index = remainingText.indexOf(keyword);
      if (index !== -1 && (delimiterIndex === -1 || index < delimiterIndex)) {
        delimiterIndex = index;
      }
    }

    const result = delimiterIndex !== -1 
      ? remainingText.substring(0, delimiterIndex) 
      : remainingText;

    return result.trim();
  };

  const extractUntilSpace = (text, startIndex, numSpaces) => {
    const normalizedText = text.replace(/\s/g, ' ');
    const remainingText = normalizedText.substring(startIndex);

    let spaceCount = 0;
    let endIndex = remainingText.length;

    for (let i = 0; i < remainingText.length; i++) {
      if (remainingText[i] === ' ') {
        spaceCount++;
        if (spaceCount === numSpaces) {
          endIndex = i;
          break;
        }
      }
    }

    const result = remainingText.substring(0, endIndex);
    return result.trim();
  };

  const uploadAndDetectText = async (file) => {
    setLoading(true); // Set loading to true before the request

    const formData = new FormData();
    formData.append('file', file);

    try {
      const res = await fetch(`${process.env.REACT_APP_MASTER_URL}/detect-text`, {
        method: 'POST',
        body: formData,
      });

      const data = await res.json();

      const nama = extractText(data.text, 70);
      const length1 = nama.length + 70;

      const tempatLahir = extractText(data.text, length1 + 17);
      const length2 = length1 + 17 + tempatLahir.length;

      const jenisKelaminIndexStart = length2 + 12;
      const jenisKelamin = extractUntilSpace(data.text, jenisKelaminIndexStart, 1);

      const jenisPekerjaanIndexStart = length2 + 13 + extractUntilSpace(data.text, length2 + 12, 2).length;
      const jenisPekerjaan = extractUntilSpace(data.text, jenisPekerjaanIndexStart, 1);

      const statusPerkawinanIndexStart1 = jenisPekerjaanIndexStart + jenisPekerjaan.length;
      const statusPerkawinanLength = extractStatusPerkawinan(data.text, statusPerkawinanIndexStart1).length;
      const statusPerkawinan = extractText(data.text, statusPerkawinanIndexStart1 + statusPerkawinanLength + 2);

      const alamatIndexStart = statusPerkawinanIndexStart1 + statusPerkawinanLength + 2 + statusPerkawinan.length;
      const alamat = extractText(data.text, alamatIndexStart + 18);
      const rtIndexStart = alamatIndexStart + 18 + alamat.length;
      const rt = data.text.substring(rtIndexStart, rtIndexStart + 4);

      const rwIndexStart = rt.length + rtIndexStart + 1;
      const rw = data.text.substring(rwIndexStart, rwIndexStart + 4);

      const kelIndexStart = rw.length + rwIndexStart + 5;
      const kel = extractText(data.text, kelIndexStart);

      const kecIndexStart = kel.length + kelIndexStart + 3;
      const kec = extractUntilCstm(data.text, kecIndexStart, 'Kode');

      const kabIndexStart = kec.length + kecIndexStart + 44;
      const kab = extractText(data.text, kabIndexStart);

      const provIndexStart = kab.length + kabIndexStart + 4;
      const prov = data.text.substring(provIndexStart);

      setNama(nama);
      setTempatLahir(tempatLahir);
      setTanggalLahir(data.text.substring(length2, length2 + 11));
      setJenisKelamin(jenisKelamin);
      setStatusPerkawinan(statusPerkawinan);
      setJenisPekerjaan(jenisPekerjaan);
      setAlamat(`${alamat} RT ${rt} RW ${rw} Kel.${kel} Kec.${kec} Kab./Kota ${kab} Provinsi ${prov}`);
      setDetectedText(data.text);

    } catch (error) {
      console.error('Error during text detection:', error);
    } finally {
      setLoading(false); // Set loading to false after the request
    }
  };

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      onSelectFile(acceptedFiles[0]);
    }
  }, []);

  const onPaste = (event) => {
    const items = event.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf('image') !== -1) {
        const file = items[i].getAsFile();
        onSelectFile(file);
        break;
      }
    }
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(false);
  };

  const deleteImage = () => {
    setSrc(null);
    setDetectedText(null);
    setNama(null);
    setTanggalLahir(null);
    setTempatLahir(null);
    setJenisKelamin(null);
    setAlamat(null);
    setStatusPerkawinan(null);
    setJenisPekerjaan(null);
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.7)', // semi-transparan putih
    zIndex: 9999, // pastikan di atas elemen lain
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const stylespinner = {
    position: 'fixed',        // Membuat overlay tetap di posisi tetap
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Transparansi background
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,             // Pastikan overlay berada di atas konten lain
  };
  

  return (
    <>
      {loading && (
        <div style={stylespinner}>
          <HashLoader
            color={'#301E67'}
            loading={loading}
            size={70}
            textAlign='centered'
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      )}
      <div className="section is-fullheight" style={{ 
        backgroundColor: '#1b48f1'
      }}>
        <div className='field'></div>
        <div className="container">
          <div className="column is-fullheight">
            <div className="box">
              <img 
                src={`${process.env.REACT_APP_MASTER_URL2}/logonusamba.png`}  
                alt="Not Found" 
                width={300} 
                height={300}
              />
              <label className="label" style={styleTitle}>
                <center>
                  FORM DUKCAPIL <br/> BPR NUSAMBA BRONDONG
                </center>
              </label>
              
              {/* Upload Image and Text Detection Section */}
              <div className="App">
                <div>
                  <button onClick={openModal}>Upload Image</button>
                  {src && <button onClick={deleteImage}>Delete Image</button>}
                </div>
                {src && (
                  <div>
                    <img alt="Uploaded" style={{ width: '800px', height: '400px' }} src={src} />
                  </div>
                )}
                {detectedText && (
                  <div>
                    <h3>Detected Text:</h3>
                    <p>{detectedText}</p>
                    <p>Nama: {nama}</p>
                    <p>Tempat Lahir: {tempatLahir}</p>
                    <p>Tanggal Lahir: {tanggalLahir}</p>
                    <p>Jenis Kelamin: {jenisKelamin}</p>
                    <p>Status Perkawinan: {statusPerkawinan}</p>
                    <p>Jenis Pekerjaan: {jenisPekerjaan}</p>
                    <p>Alamat : {alamat}</p>
                  </div>
                )}
  
                <Modal isOpen={isModalOpen} onRequestClose={closeModal} contentLabel="Upload Image">
                  <div 
                    {...getRootProps()} 
                    style={{ border: '2px dashed #ccc', padding: '20px', textAlign: 'center' }}
                  >
                    <input {...getInputProps()} />
                    <p>Drag and drop an image here, or click to select one</p>
                    <p>Or paste an image from your clipboard</p>
                    <button style={{ marginTop: '20px' }} onClick={closeModal}>Cancel</button>
                  </div>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  
  
  
  
}

export default Dukcapil;
